import { Fragment, useState } from "react";

import WhyChooseImg from "../../../assets/images/why-choose.png";
import VisitImg from "../../../assets/images/visit.png";
import HousePlanImg from "../../../assets/images/house-plan.png";
import PeaceImg from "../../../assets/images/peace.png";
import AmenitiesImg from "../../../assets/images/amenities.png";

import "./WhyChooseStyle.css";
import { useStaticPageContent } from "../../../hooks/useStaticPageContent";
import { staticContentDefaults } from "../../../data/staticContentDefaults";
import { getStaticContentImage } from "../../../utils/staticContentImages";
import CmsRichText from "../../common/CmsRichText";
import { mergeSplitHeadingHtml } from "../../../utils/cmsHeadingUtils";

const defaultFeatureImages = {
  VisitImg,
  HousePlanImg,
  PeaceImg,
  AmenitiesImg,
};

const WhyChoose = () => {
  const pageContent = useStaticPageContent("shared");
  const content =
    pageContent?.whyChoose || staticContentDefaults.shared.whyChoose;
  const features = content?.features?.length
    ? content.features
    : staticContentDefaults.shared.whyChoose.features;

  const [isContentExpanded, setIsContentExpanded] = useState({
    WhyChooseImg: false,
    VisitImg: false,
    HousePlanImg: false,
    PeaceImg: false,
    AmenitiesImg: false,
  });
  const toggleContent = (section) => {
    setIsContentExpanded((prevState) => ({
      ...prevState,
      [section]: !prevState[section],
    }));
  };

  const getReadMoreText = (section) => {
    return (
      isContentExpanded[section] ? content.readLessLabel : content.readMoreLabel
    ).replace(/(Read More|Read Less)/, (match) => match);
  };

  const renderFeatureBody = (feature) => {
    if (feature.hasReadMore) {
      return (
        <>
          <CmsRichText as="span" value={feature.bodyShort} />
          {isContentExpanded[feature.key] && (
            <>
              <br />
              <CmsRichText as="span" value={feature.bodyExpanded} />
            </>
          )}
          <a
            onClick={() => toggleContent(feature.key)}
            className="read-more"
          >
            <br />
            {getReadMoreText(feature.key)}
          </a>
        </>
      );
    }

    return <CmsRichText as="span" value={feature.body} />;
  };

  return (
    <Fragment>
      <div className="why-choose-us">
        <div className="container-fluid my-container">
          <div className="row">
            <div className="col-12 col-lg-4">
              <div className="heading-sec">
                <img
                  src={getStaticContentImage(
                    content.sectionImage,
                    WhyChooseImg
                  )}
                />
              </div>
            </div>
            <div className="col-12 col-lg-8">
              <div className="heading-sec inner">
                <h2>
                  <CmsRichText as="span" value={mergeSplitHeadingHtml(content)} />
                </h2>
                <p>
                  <CmsRichText as="span" value={content.introParagraph} />
                </p>
              </div>
              <div className="row">
                {features.map((feature) => (
                  <div
                    className="col-12 col-lg-6 col-md-6"
                    key={feature.key}
                  >
                    <div className="whychoose-sec">
                      <img
                        src={getStaticContentImage(
                          feature.image,
                          defaultFeatureImages[feature.key]
                        )}
                      />
                      <h3>
                        <CmsRichText as="span" value={feature.title} />
                      </h3>
                      <p>{renderFeatureBody(feature)}</p>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>
    </Fragment>
  );
};

export default WhyChoose;
